(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/start/assets/react/components/navigation-buttons.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/start/assets/react/components/navigation-buttons.js');

'use strict';

const Button = svs.ui.ReactButton;
const Icon = svs.ui.ReactIcon;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const NavigationButtons = () => {
  const wrapperRef = React.useRef(null);
  React.useEffect(() => {
    if (wrapperRef.current) {
      wrapperRef.current.classList.add('animate-on-load');
      setTimeout(() => {
        if (wrapperRef.current) {
          wrapperRef.current.classList.remove('animate-on-load');
        }
      }, 3000); 
    }
  }, []);
  const handleClick = page => {
    svs.components.analytics.trackEvent({
      category: 'eurojackpot_startPage',
      action: 'CTA_gameEntry',
      opt_label: page
    }, () => {
      const url = page.toLowerCase().replace(/ /g, '-').replace(/ö/g, 'o').replace(/ä/g, 'a');
      svs.utils.url.navigate("eurojackpot/".concat(url));
    });
  };
  const defaultComponents = React.createElement("div", {
    className: "eurojackpot-navigation-buttons"
  }, React.createElement("div", {
    className: "buttons-body"
  }, React.createElement(Button, {
    className: "btn btn-eurojackpot",
    onClick: () => handleClick('Förläng spel'),
    type: "button"
  }, "F\xF6rl\xE4ng spel"), React.createElement(Button, {
    className: "btn btn-eurojackpot",
    onClick: () => handleClick('Resultat'),
    type: "button"
  }, "Resultat"), React.createElement(Button, {
    className: "btn btn-eurojackpot",
    onClick: () => handleClick('Andelsspel'),
    type: "button"
  }, "Andelsspel"), React.createElement(Button, {
    className: "btn btn-eurojackpot",
    onClick: () => handleClick('Systemspel'),
    type: "button"
  }, "Systemspel"), React.createElement(Button, {
    className: "btn btn-eurojackpot",
    onClick: () => handleClick('Prenumeration'),
    type: "button"
  }, "Prenumeration"), React.createElement(Button, {
    block: true,
    className: "btn btn-eurojackpot with-icon",
    onClick: () => handleClick('Spelguide'),
    type: "button"
  }, "Spelguide", ' ', React.createElement("span", null, React.createElement(Icon, {
    icon: "information",
    size: "300"
  })))));
  const selfServiceComponents = React.createElement(React.Fragment, null, React.createElement("div", {
    className: "eurojackpot-navigation-buttons"
  }, React.createElement("div", {
    className: "buttons-body"
  }, React.createElement(Button, {
    className: "btn btn-eurojackpot",
    onClick: () => handleClick('Systemspel'),
    type: "button"
  }, "Systemspel"), React.createElement(Button, {
    className: "btn btn-eurojackpot",
    onClick: () => handleClick('Resultat'),
    type: "button"
  }, "Resultat"))), React.createElement("div", {
    className: "eurojackpot-navigation-button-wrapper"
  }, React.createElement("div", {
    className: "wrapper-body"
  }, React.createElement(Button, {
    block: true,
    className: "btn btn-eurojackpot with-icon",
    onClick: () => handleClick('Spelguide'),
    type: "button"
  }, "Spelguide", ' ', React.createElement("span", null, React.createElement(Icon, {
    icon: "information",
    size: "300"
  }))))));
  return React.createElement("div", {
    className: "eurojackpot-navigation-buttons-wrapper",
    ref: wrapperRef
  }, isSelfService ? selfServiceComponents : defaultComponents);
};
setGlobal('svs.eurojackpot.react.components', {
  NavigationButtons
});

 })(window);